<template>
  <template-item v-if="hasMode" label="标题的值" layout="flex">
    <div class="flex-fill flex-row">
      <div class="flex-fill">
        <tree-cascade-selector
          :deep="finalDeep"
          :root-source="dataSource"
          :multiple="mode === modeValue.multi"
          :show-prefix="showPrefix"
          :separator="separator"
          v-model="valueProxy"
        />
      </div>
      <div v-if="showSwitch" class="flex-auto" style="padding-top: 5px">
        <el-switch
          v-model="showPrefix"
          :active-text="activeText"
          :inactive-text="inactiveText"
        />
      </div>
    </div>
  </template-item>
</template>
<script>
import { Switch } from "element-ui";
import {
  CityOption,
  CountyOption,
  ProvinceOption,
} from "@/components/excel/schema/label/type/area";
import {
  MultiSelector,
  SingleSelector,
} from "@/components/excel/schema/label/mode";
import TreeCascadeSelector from "@/components/selector/TreeCascadeSelector";
import {
  DayOption,
  MonthOption,
  YearOption,
} from "@/components/excel/schema/label/type/date";
import {
  HourOption,
  MinuteOption,
  SecondOption,
} from "@/components/excel/schema/label/type/time";
import TemplateItem from "@/components/excel/designer/template/TemplateItem";
import { ValueTransfer } from "@/components/excel/schema/label/transfer";
import { NameProvider } from "@/components/excel/schema/label/provider";
import { findSource } from "@/utils/excel/LabelDataSource";
import { generateArray } from "@/utils/excel/CommonDataSource";

export default {
  name: "title-type-selector",
  components: {
    TemplateItem,
    TreeCascadeSelector,
    [Switch.name]: Switch,
  },
  props: {
    type: {
      type: Number,
    },
    value: [Array, Number],
    parentValue: [Array, Number],
    mode: Number,
  },
  data() {
    const single = SingleSelector.value;
    const multi = MultiSelector.value;
    return {
      dataSource: [],
      showPrefix: false,
      modeValue: {
        single,
        multi,
      },
    };
  },
  computed: {
    hasMode() {
      const { mode, modeValue } = this;
      return mode === modeValue.single || mode === modeValue.multi;
    },
    separator() {
      const { type } = this.$props;
      if (
        type === ProvinceOption.value ||
        type === CityOption.value ||
        type === CountyOption.value
      ) {
        return "/";
      }
      if (
        type === YearOption.value ||
        type === MonthOption.value ||
        type === DayOption.value
      ) {
        return "-";
      }
      if (
        type === HourOption.value ||
        type === MinuteOption.value ||
        type === SecondOption.value
      ) {
        return ":";
      }
      return null;
    },
    normalDeep() {
      const { type } = this.$props;
      if (type === CityOption.value) {
        return 2;
      }
      if (type === CountyOption.value) {
        return 3;
      }
      return 1;
    },
    finalDeep() {
      const { type, parentValue } = this.$props;
      if (parentValue) {
        return 1;
      }
      return this.normalDeep;
    },
    showSwitch() {
      const { type, parentValue } = this.$props;
      if (parentValue) {
        return false;
      }
      return (
        type === CityOption.value ||
        type === CountyOption.value ||
        type === YearOption.value ||
        type === MonthOption.value ||
        type === DayOption.value ||
        type === HourOption.value ||
        type === MinuteOption.value ||
        type === SecondOption.value
      );
    },
    activeText() {
      const { type } = this.$props;
      switch (type) {
        case CityOption.value:
          return "包含省";
        case CountyOption.value:
          return "包含省/市";
        case YearOption.value:
        case MonthOption.value:
        case DayOption.value:
        case HourOption.value:
        case MinuteOption.value:
        case SecondOption.value:
          return "显示单位";
      }
      return null;
    },
    inactiveText() {
      const { type } = this.$props;
      switch (type) {
        case CityOption.value:
          return "只显示市";
        case CountyOption.value:
          return "只显示区/县";
        case YearOption.value:
        case MonthOption.value:
        case DayOption.value:
        case HourOption.value:
        case MinuteOption.value:
        case SecondOption.value:
          return "隐藏单位";
      }
      return null;
    },
    valueProxy: {
      get() {
        const { value } = this.$props;
        if (value) {
          return value;
        }
        if (this.mode === this.modeValue.multi) {
          return [];
        }
        return null;
      },
      set(value) {
        this.updateValue(value);
      },
    },
  },
  watch: {
    type(type) {
      this.handleChangeType(type);
    },
    mode(mode) {
      if (this.value === null || this.value === undefined) {
        return;
      }
      if (mode === this.modeValue.multi) {
        this.updateValue([this.value]);
      } else if (Array.isArray(this.value)) {
        const first = this.value[0];
        console.log(first);
        if (first === undefined) {
          this.updateValue(null);
        } else {
          this.updateValue(first);
        }
      }
    },
    value(value) {
      this.updateTitle(value);
    },
    parentValue() {
      this.handleChangeType(this.type);
    },
  },
  methods: {
    async handleChangeType(type) {
      if (type === null || type === undefined) {
        return;
      }
      this.dataSource = await findSource(type, this.parentValue);
    },
    updateValue(value) {
      this.emitChangeValue(value);
    },
    obtainFullValue(value) {
      if (this.normalDeep === 1) {
        return value;
      }
      const { parentValue } = this.$props;
      if (!parentValue) {
        return value;
      }
      const list = generateArray(this.normalDeep);
      const values = Array.isArray(parentValue)
        ? parentValue.concat(value)
        : [parentValue].concat(value);
      return list.replace(list.length - values.length, values.length, values);
    },
    updateTitle(value) {
      if (!value) {
        this.emitChangeTitle(null);
        return;
      }
      const provider = NameProvider[this.type];
      if (!provider) {
        this.emitChangeTitle(null);
        return;
      }
      const fullValue = this.obtainFullValue(value);
      const transfer = ValueTransfer[this.type];
      const option = {
        value: fullValue,
        separator: this.separator,
        showPrefix: this.showPrefix,
        showSuffix: this.showPrefix,
      };
      if (transfer) {
        const names = provider({
          ...option,
          value: transfer(fullValue, this.mode),
        });
        this.emitChangeTitle(names.join());
        return;
      }
      const names = provider(option);
      this.emitChangeTitle(names.join());
    },
    emitChangeTitle(value) {
      this.$emit("update:title", value);
      this.$emit("change-title", value);
    },
    emitChangeValue(value) {
      this.$emit("update:value", value);
      this.$emit("change-value", value);
    },
  },
  mounted() {
    console.log(this.$props.type);
    console.log(this.$props.mode);
    console.log(this.$props.value);
    const { type } = this.$props;
    this.handleChangeType(type);
  },
};
</script>
